"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledgeProject.list': 'Proyectos',
    'route.knowledgeProject.create': 'Agregar proyecto',
    'route.knowledgeProject.edit': 'Editar proyecto',
};
